/**
 * Lightweight, SSR-safe Google Analytics (GA4) event helper.
 *
 * gatsby-plugin-google-gtag injects gtag.js (Measurement ID G-QPVM719Q38) and
 * defines window.gtag. Page views (initial load + SPA route changes) are sent
 * by the plugin itself; this helper is only for the custom interaction events
 * fired from gatsby-browser.js.
 */

/**
 * Send a custom GA4 event. No-ops during SSR and in development (where gtag is
 * not injected), so it is always safe to call.
 *
 * @param {string} event - GA4 event name, e.g. 'steam_click'
 * @param {Object} [params] - event parameters
 */
export function trackEvent(event, params = {}) {
  if (typeof window === 'undefined' || !event) return
  if (typeof window.gtag === 'function') {
    window.gtag('event', event, params)
  }
}

export default trackEvent
